
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","viewBox":"0 0 26 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.401 2.365h8.404a1.2 1.2 0 011.2 1.201v15.607a1.2 1.2 0 01-1.2 1.2h-7.907l-2.05 2.05a1.197 1.197 0 01-1.697 0l-2.049-2.05H2.195a1.2 1.2 0 01-1.2-1.2V3.566a1.2 1.2 0 011.2-1.2H10.6c.318 0 .624.126.849.351L13 4.27l1.552-1.552a1.2 1.2 0 01.849-.352zM3.396 17.972V4.766h6.706l1.697 1.698v12.212l-.351-.352a1.197 1.197 0 00-.849-.352H3.396zM22.604 4.766v13.206h-7.203c-.318 0-.624.126-.849.352l-.351.351V6.464l1.697-1.698h6.706zM6.997 9.57H10.6V7.168H6.997v2.401zm3.603 3.6H4.596v-2.4H10.6v2.4zm-6.003 3.602H10.6v-2.401H4.596v2.401zm16.808 0H15.4v-2.401h6.003v2.401zM15.4 13.171h6.003V10.77H15.4v2.4zm3.602-3.602H15.4V7.168h3.602v2.401z","fill":"currentColor"}})])
          )
        }
      }
    